/**
 * Is the account being viewed read-only for this person?
 *
 * `sub_user.read_only` is the authority. Under account contexts the API resolves
 * it per account from the membership row, so the same login can be read-only on
 * one account and full admin on their own — see docs/multi-account-membership.md
 * in the tempstickapi repo.
 *
 * The top-level `read_only` flag is an OR here, where it used to be an AND. As an
 * AND, read-only mode only engaged when both were set, and nothing in the API
 * populates a top-level `read_only` on the user payload — so the extra condition
 * could only ever suppress the restriction. Requiring either one keeps any caller
 * that does set it working, without letting a missing field silently hand write
 * access to a read-only member.
 */
const isAccountReadOnly = () => {
  if(window.currentUser) {

    if(!window.currentUser.is_sub_user) {
      return false;
    }

    return !!(
      (window.currentUser.sub_user && window.currentUser.sub_user.read_only == 1) ||
      window.currentUser.read_only == 1
    );

  }

  // called too soon
  console.error('isAccountReadyOnly called before user was authenticated');
  return true;

};

export default isAccountReadOnly;
